import React from 'react';
import { Button, PageContainer } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import './success.css';

const SuccessNode = ({ accountId }) => {
  return (
    <PageContainer className="successNode-Container">
      <div className="successNode-card-Container">
        <div className="successNode-Icon">
          <img
            src="/images/workflow/Group-123627.png"
            alt="Check Icon"
            className="successNode-checkIcon"
          />
        </div>
        <h2 className="successNode-Title">
          Your account has been <br />
          created successfully
        </h2>
        <p className="successNode-Description">
          Now you can sign in all new Subscriber Connect and you can track your
          order, pay bills, activate your service and more.
        </p>
        <p className="successNode-subscriberId">
          Account ID:{' '}
          <span className="successNode-subscriberIdValue">
            <b>{accountId}</b>
          </span>
        </p>
        <Button
          node={'successNode'}
          customId={ELEMENT_IDS.NEXT_STEP_BUTTON}
          label="Confirm Your Order"
        />
      </div>
    </PageContainer>
  );
};

export default SuccessNode;
